import * as types from "./types";

export const updateWorkspaceSettings = (data) => (dispatch) =>
    dispatch({ type: types.UPDATE_WORKSPACE_SETTINGS, payload: data });
